import axios from 'axios'

// Store an admin/director/assistant is currently working from /admin/task/store/:storeId.
// Sent as X-Acting-Store so store-scoped API handlers act on that store; the backend ignores it for other roles.
let actingStoreId = null

export const setActingStore = (storeId) => {
	actingStoreId = storeId || null
}

export const withActingStoreHeader = (config) => {
	if (actingStoreId) {
		config.headers = config.headers || {}
		config.headers['X-Acting-Store'] = actingStoreId
	}
	return config
}

// The staff order board also calls the default axios instance directly; installed once from index.js
export const installActingStoreInterceptor = () => {
	axios.interceptors.request.use(withActingStoreHeader)
}
